import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { AlertBannerEntity } from './alert-banner.entity';
import { BaseEntity } from './base.entity';
import { ObjectEntity } from './object.entity';

@Index('_fk__alert_banner__id', ['fkAlertBannerId'], {})
@Index('_fk__object__id_reference', ['fkObjectIdReference'], {})
@Entity('_alert_banner_map')
export class AlertBannerMapEntity extends BaseEntity {
	@Column('int', { name: '_fk__alert_banner__id', unsigned: true })
	public fkAlertBannerId!: number;

	@Column('int', {
		name: '_fk__object__id_reference',
		unsigned: true,
		default: () => "'0'",
	})
	public fkObjectIdReference!: number;

	@Column('int', { name: '_referenceId', unsigned: true, default: () => "'0'" })
	public referenceId!: number;

	@ManyToOne(
		() => AlertBannerEntity,
		(alertBanner) => alertBanner.alertBannerMaps,
		{
			onDelete: 'NO ACTION',
			onUpdate: 'NO ACTION',
		},
	)
	@JoinColumn([{ name: '_fk__alert_banner__id', referencedColumnName: 'id' }])
	public fkAlertBanner!: AlertBannerEntity;

	@ManyToOne(() => ObjectEntity, (object) => object.alertBannerMaps, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([
		{ name: '_fk__object__id_reference', referencedColumnName: 'id' },
	])
	public fkObjectIdReference2!: ObjectEntity;
}
